import React from 'react';
import { HiSearch, HiLightningBolt, HiCheckCircle } from 'react-icons/hi';
import './ValueProps.css';

export default function ValueProps() {
  return (
    <section className="section valueProps anchor" id="value">
      <div className="container">
        <header className="valueProps__header">
          <h2 className="valueProps__title">The 3-Step Delivery Method</h2>
          <p className="valueProps__subtitle">
            Every engagement follows a structured framework - no guessing, no vague plans. Here's
            exactly how I turn broken delivery into reliable execution.
          </p>
        </header>

        <div className="valueProps__grid">
          <article className="valueProps__card">
            <div className="valueProps__cardHeader">
              <HiSearch className="valueProps__cardIcon" />
              <h3>Step 1 - Diagnose</h3>
            </div>
            <p>
              I audit your delivery pipeline, system gaps, team blockers, and risk areas. You get a
              clear, honest picture of exactly what's broken and why - before any work begins.
            </p>
          </article>
          <article className="valueProps__card">
            <div className="valueProps__cardHeader">
              <HiLightningBolt className="valueProps__cardIcon" />
              <h3>Step 2 - Fix &amp; Structure</h3>
            </div>
            <p>
              I implement a delivery framework tailored to your team - restructuring sprint cadence,
              stabilising systems, and eliminating the recurring failure points driving your delays.
            </p>
          </article>
          <article className="valueProps__card">
            <div className="valueProps__cardHeader">
              <HiCheckCircle className="valueProps__cardIcon" />
              <h3>Step 3 - Deliver &amp; Hold</h3>
            </div>
            <p>
              I manage delivery to completion with weekly progress reporting and full handoff
              documentation - so your team keeps operating at the new standard after I leave.
            </p>
          </article>
        </div>
      </div>
    </section>
  );
}
